import { Path, Svg } from '@react-pdf/renderer'

export const TimelineIcon = () => (
  <Svg height={14} viewBox='0 0 58 58' width={14}>
    <Path
      d='M7.25 29H41.0833M7.25 14.5H50.75M7.25 43.5H50.75'
      fill='none'
      stroke='#000000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={4.35}
    />
  </Svg>
)
